import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import 'style-loader!normalize.css';
import 'style-loader!../assets/styles/styles.less';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule
  ],
  providers: []
})
export class AssetsModule { }



// WEBPACK FOOTER //
// ./~/@c4/assets/src/app/assets.module.ts